import functionCommon from "../common/function";
import CONSTANT from "../constant/constant";
import { leaveHistoryConstants } from "../constant/leaveHistory.constant";
import { leaveHistory } from "../services/leaveHistory.service";

const _errorCode = CONSTANT.errorCode;

export const getLeaveHistory = (data, isPaging = false) => {
    const params = {
        ...data,
        dayFrom: functionCommon.revertDateFormat(data.dayFrom),
        dayTo: functionCommon.revertDateFormat(data.dayTo),
    };

    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return (dispatch) => {
        isPaging && dispatch(paging());
        leaveHistory.getListHistory(params).then((res) => {
            if (!res) return;
            switch (res["http_code"]) {
                case _errorCode.APISuccess:
                    dispatch(success(res.result));
                    break;

                case _errorCode.TOKENExpired:
                    functionCommon.logout();
                    break;

                case _errorCode.APIInvalids:
                    functionCommon.logout();
                    break;

                case _errorCode.ClientNotPermission:
                    functionCommon.logout();
                    break;

                default:
                    window.location = "/error/404";
                    break;
            }
        });
    };

    function success(data) {
        return { type: leaveHistoryConstants.GET_LIST_SUCCESS, data };
    }

    function paging() {
        return { type: leaveHistoryConstants.GET_LIST };
    }
};

export const clearLoadingHistory = () => {
    return (dispatch) => {
        dispatch({ type: leaveHistoryConstants.CLEAR_LOADING });
    };
};
